export enum FullstoryTypes {
  Bootstrap = 'Fullstory.Bootstrap',
  OrgAdded = 'Fullstory.OrgAdded',
  AcceptTermsAndConditions = 'Fullstory.AcceptTermsAndConditions',
  SetNotificationsLastSeen = 'Fullstory.SetNotificationsLastSeen',
}

export enum FullstoryRequestTypes {
  GetAllOrgsRequest = 'Fullstory.GetAllOrgsRequest',
  GetAllOrgsSuccess = 'Fullstory.GetAllOrgsSuccess',
  GetAllOrgsFailure = 'Fullstory.GetAllOrgsFailure',
  UpdateAppearanceModeRequest = 'Fullstory.updateAppearanceModeRequest',
  UpdateAppearanceModeSuccess = 'Fullstory.updateAppearanceModeSuccess',
  UpdateAppearanceModeFailure = 'Fullstory.updateAppearanceModeFailure',
  UpdateOrgLevel0Request = 'Fullstory.updateOrgLevel0Request',
  UpdateOrgLevel0Success = 'Fullstory.updateOrgLevel0Success',
  UpdateOrgLevel0Failure = 'Fullstory.updateOrgLevel0Failure',
}

export interface UserInfo {
  email: string;
  firstName: string;
  lastName: string;
}

export interface TermsAndConditons {
  currentVersion: number;
  acceptedVersion: number;
}
